module.exports = __webpack_public_path__ + "img/painPerceptionScale_8.74d2426b.png";